import { createToggle } from "@callcenter/effector-helpers"

export const [$isOpen, toggle, _, close] = createToggle()
